import type { Hydratable } from '@vimcar/mvvm/hydratable'
import type { Request } from '@vimcar/shared-utils/request'
import type { Values } from '#models/Nodes/ValuedNode'
import type { Observable } from 'rxjs'

import hydratable from '@vimcar/mvvm/hydratable'
import * as mobx from 'mobx'

import {
  ATTRIBUTE_CAR,
  ATTRIBUTE_ENGINE,
  ATTRIBUTE_BYEAR,
  ATTRIBUTE_CARDATA,
  ATTRIBUTE_AFFECTEDCAR,
  ATTRIBUTE_NUMBERCARS,
  ATTRIBUTE_STARTSERVTIMESTAMP,
  ATTRIBUTE_ENDSERVTIMESTAMP,
  ATTRIBUTE_STARTSERVODO,
  ATTRIBUTE_ENDSERVODO,
  ATTRIBUTE_ODOTIMESTAMP,
  ATTRIBUTE_ODOMETER,
  ATTRIBUTE_TRIPSSTART,
  ATTRIBUTE_TRIPSEND,
  ATTRIBUTE_TAXOFFICE,
  ATTRIBUTE_CUSTOMERID,
  ATTRIBUTE_CLASS,
  ATTRIBUTE_DCONFIG,
} from '../../utils/constants'
import i18n from '../../utils/i18n'

const tp = i18n.prefixWithoutTestId('Tickets')

type _Pipedrive = {
  createLead: (info: LeadInfo) => Observable<void>
  _createPayload: (info: LeadInfo) => LeadPayload
}

export type LeadInfo = {
  company?: null | string
  name?: string
  requestEmail?: string
  telephone?: null | string
  message?: string
  customValues: object
} & Values

export type LeadPayload = {
  stageId: number
  pipedriveId: number
  subject: string
  team: string
  company?: string
  name?: string
  telephone?: string
  requestEmail: string
  message?: string
  numberOfCars?: number
}
// @ts-expect-error@2314
export type Pipedrive = Hydratable<_Pipedrive>

export type PipedriveOptions = {
  request: Request
  pipedriveBaseUrl: string
}

const tryAppendAttribute = (data, key, label) => {
  const value =
    (data.customValues && data.customValues[key]) ||
    (data.attrs && data.attrs.get(key)) ||
    data[key]
  if (label && value) return `${label}: ${value} // `
  if (value) return value
  return null
}

const mkPipedrive = hydratable(
  ({ request, pipedriveBaseUrl }: PipedriveOptions) => {
    const pipedrive = mobx.observable({
      createLead: (info) => {
        const body = pipedrive._createPayload(info)
        return request(`${pipedriveBaseUrl}/create-lead`, {
          method: 'POST',
          body,
        })
      },
      _createPayload: (info) => ({
        stageId: info.stageId,
        pipedriveId: info.pipedriveId,
        subject: info.subject,
        team: info.team,
        company: info.company || undefined,
        name: info.name,
        telephone: info.telephone || undefined,
        requestEmail: info.requestEmail,
        message: [
          tryAppendAttribute(info, ATTRIBUTE_BYEAR, tp('build-year')),
          tryAppendAttribute(info, ATTRIBUTE_CAR, tp('group')),
          tryAppendAttribute(info, ATTRIBUTE_ENGINE, tp('engine')),
          tryAppendAttribute(info, ATTRIBUTE_AFFECTEDCAR, tp('affected-car')),
          tryAppendAttribute(info, ATTRIBUTE_TAXOFFICE, tp('tax-office')),
          tryAppendAttribute(info, ATTRIBUTE_NUMBERCARS, tp('number-cars')),
          tryAppendAttribute(
            info,
            ATTRIBUTE_STARTSERVTIMESTAMP,
            tp('service-time-start'),
          ),
          tryAppendAttribute(
            info,
            ATTRIBUTE_ENDSERVTIMESTAMP,
            tp('service-time-end'),
          ),
          tryAppendAttribute(
            info,
            ATTRIBUTE_STARTSERVODO,
            tp('odometer-start'),
          ),
          tryAppendAttribute(info, ATTRIBUTE_ENDSERVODO, tp('odometer-end')),
          tryAppendAttribute(info, ATTRIBUTE_ODOMETER, tp('odometer')),
          tryAppendAttribute(info, ATTRIBUTE_ODOTIMESTAMP, tp('odometer-time')),
          tryAppendAttribute(
            info,
            ATTRIBUTE_TRIPSSTART,
            tp('trips-time-start'),
          ),
          tryAppendAttribute(info, ATTRIBUTE_TRIPSEND, tp('trips-time-end')),
          tryAppendAttribute(info, ATTRIBUTE_CUSTOMERID, tp('customer-id')),
          tryAppendAttribute(info, ATTRIBUTE_CLASS, tp('class')),
          tryAppendAttribute(info, ATTRIBUTE_DCONFIG, tp('dongle-config')),
          tryAppendAttribute(info, ATTRIBUTE_CARDATA, tp('car-data')),
          `${info.message}`,
        ]
          .filter((item) => item !== null)
          .reduce((acc, val) => acc + val),
        numberOfCars: info.customValues && info.customValues.numberOfCars,
      }),
    })
    return pipedrive
  },
  'Pipedrive',
)

export default mkPipedrive
